import { Box, Divider, Drawer, IconButton, Modal } from "@mui/material";
import {
	AccentColor,
	NeutralColor,
	PrimaryColor,
	SecondaryColor,
} from "node-library/dist/colors";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import { FrontendOrderItem } from "node-library/dist/portal";
import { useTranslation } from "react-i18next";
import { getServiceName } from "../../../helpers/sampleHelper";
import { CustomDrawer } from "../../../common-components/drawers/drawer";

interface Props {
	headerDescription?: string;
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
	item: FrontendOrderItem | null;
}

export default function ItemDetailDrawer(props: Props) {
	const { t: translation } = useTranslation();

	const { headerDescription, open, setOpen, item } = props;
	const itemDetailContent: React.ReactNode = item ? (
		<div className="item-detail-content">
			<div className="item-detail-content-card">
				<div
					style={{
						backgroundColor: AccentColor.GREEN,
						color: NeutralColor.NEUTRAL_GREY_900,
					}}
					className="typography-caption item-tag"
				>
					{translation("Instrument")}
				</div>
				<div className="typography-body-01">{item.product.productName}</div>
			</div>
			{item.service && (
				<>
					<Divider sx={{ border: "1.5px solid #c9c9c9" }}></Divider>
					<div className="item-detail-content-card">
						<div
							style={{
								backgroundColor: AccentColor.GREEN,
								color: NeutralColor.NEUTRAL_GREY_900,
							}}
							className="typography-caption item-tag"
						>
							{translation("Service")}
						</div>
						<div className="typography-body-01">
							{getServiceName(item.service, translation)}
						</div>
					</div>
				</>
			)}
		</div>
	) : (
		<></>
	);
	return (
		<CustomDrawer
			anchor={"right"}
			open={open}
			setOpen={setOpen}
			headerText={translation("ItemDetails")}
		>
			{itemDetailContent}
		</CustomDrawer>
	);
}
